export default __webpack_public_path__ + "static/media/25.c839b7b7.png";